import { Box, Divider, Typography } from '@mui/material'
import React from 'react'
import palette from '../../../common/styles/palette'

type Props = {
    title: React.ReactNode
}
export default function TitleAndDivider({ title }: Props) {
  return (
    <Box>
        <Typography
            variant="h3"
            mb={1}
            component="div"
            color={palette.brandDark}
        >
            {title}
        </Typography>
        <Divider sx={{ borderColor: palette.border, mt: 1 }} />
    </Box>
  )
}
